import { jsx as _jsx } from "react/jsx-runtime";
import { useHeroTitle } from "@hooks/useHeroTitle";
import { useMemo } from "react";
const PageH1 = ({ fallbackElement, forceFallback, ...rest }) => {
    const hasHeroTitle = useHeroTitle();
    const Wrapper = useMemo(() => {
        if (!fallbackElement) {
            return "h1";
        }
        if (forceFallback && !!fallbackElement) {
            return fallbackElement;
        }
        else {
            return hasHeroTitle ? fallbackElement : "h1";
        }
    }, [hasHeroTitle, fallbackElement, forceFallback]);
    return _jsx(Wrapper, { ...rest });
};
export default PageH1;
